import RequestPageTwo from "./RequestPageTwo";

const LifeLongMembershipsReq = () => {
    return (
        <RequestPageTwo title="Life Long Membership Requests"
            fetchUrl="/get-lifelong-membership-requests"
            editEndpoint="update-lifelong-membership-requests"
            deleteEndpoint="lifelong-membership-requests"
            statusEndpoint="update-lifelong-membership-requests" />
    );
}

export default LifeLongMembershipsReq;
